export const MENU_DATA = [
  {
    name: "Supermarket",
    data: [
      {
        name: "Food Cupboard",
        menu: [
          "Rice",
          "Yam",
          "Cassava Flour",
          "Beans",
          "Poundo Yam",
          "Yam Flour",
        ],
      },
      {
        name: "Fruits",
        menu: ["Grape", "Apple", "Peer", "Orange", "Pineapple", "Apple"],
      },
      {
        name: "Household Cleaning",
        menu: [
          "Laundry",
          "Air Fresher",
          "Dishwashing",
          "Bathroom Cleaners",
          "Toilet Papers & Wipe",
          "Disinfectant Wipe",
        ],
      },
      {
        name: "Beer, Wine & Spirit",
        menu: ["Beer", "Vodka", "Red wine", "Whiskey", "Liquors", "Champaigne"],
      },
    ],
  },
  {
    name: "Health",
    data: [
      {
        name: "Health Cupboard",
        menu: [
          "Rice",
          "Yam",
          "Cassava Flour",
          "Beans",
          "Poundo Yam",
          "Yam Flour",
        ],
      },
      {
        name: "Fruits",
        menu: ["Grape", "Apple", "Peer", "Orange", "Pineapple", "Apple"],
      },
      {
        name: "Household Cleaning",
        menu: [
          "Laundry",
          "Air Fresher",
          "Dishwashing",
          "Bathroom Cleaners",
          "Toilet Papers & Wipe",
          "Disinfectant Wipe",
        ],
      },
      {
        name: "Beer, Wine & Spirit",
        menu: ["Beer", "Vodka", "Red wine", "Whiskey", "Liquors", "Champaigne"],
      },
    ],
  },
  {
    name: "Electronics",
    data: [
      {
        name: "Electronics Cupboard",
        menu: [
          "Rice",
          "Yam",
          "Cassava Flour",
          "Beans",
          "Poundo Yam",
          "Yam Flour",
        ],
      },
      {
        name: "Fruits",
        menu: ["Grape", "Apple", "Peer", "Orange", "Pineapple", "Apple"],
      },
      {
        name: "Household Cleaning",
        menu: [
          "Laundry",
          "Air Fresher",
          "Dishwashing",
          "Bathroom Cleaners",
          "Toilet Papers & Wipe",
          "Disinfectant Wipe",
        ],
      },
      {
        name: "Beer, Wine & Spirit",
        menu: ["Beer", "Vodka", "Red wine", "Whiskey", "Liquors", "Champaigne"],
      },
    ],
  },
  {
    name: "Apparel",
    data: [
      {
        name: "Apparel Cupboard",
        menu: [
          "Rice",
          "Yam",
          "Cassava Flour",
          "Beans",
          "Poundo Yam",
          "Yam Flour",
        ],
      },
      {
        name: "Fruits",
        menu: ["Grape", "Apple", "Peer", "Orange", "Pineapple", "Apple"],
      },
      {
        name: "Household Cleaning",
        menu: [
          "Laundry",
          "Air Fresher",
          "Dishwashing",
          "Bathroom Cleaners",
          "Toilet Papers & Wipe",
          "Disinfectant Wipe",
        ],
      },
      {
        name: "Beer, Wine & Spirit",
        menu: ["Beer", "Vodka", "Red wine", "Whiskey", "Liquors", "Champaigne"],
      },
    ],
  },
  {
    name: "Computing",
    data: [
      {
        name: "Computing Cupboard",
        menu: [
          "Rice",
          "Yam",
          "Cassava Flour",
          "Beans",
          "Poundo Yam",
          "Yam Flour",
        ],
      },
      {
        name: "Fruits",
        menu: ["Grape", "Apple", "Peer", "Orange", "Pineapple", "Apple"],
      },
      {
        name: "Household Cleaning",
        menu: [
          "Laundry",
          "Air Fresher",
          "Dishwashing",
          "Bathroom Cleaners",
          "Toilet Papers & Wipe",
          "Disinfectant Wipe",
        ],
      },
      {
        name: "Beer, Wine & Spirit",
        menu: ["Beer", "Vodka", "Red wine", "Whiskey", "Liquors", "Champaigne"],
      },
    ],
  },
  {
    name: "Home & Office",
    data: [
      {
        name: "Home Cupboard",
        menu: [
          "Rice",
          "Yam",
          "Cassava Flour",
          "Beans",
          "Poundo Yam",
          "Yam Flour",
        ],
      },
      {
        name: "Fruits",
        menu: ["Grape", "Apple", "Peer", "Orange", "Pineapple", "Apple"],
      },
      {
        name: "Household Cleaning",
        menu: [
          "Laundry",
          "Air Fresher",
          "Dishwashing",
          "Bathroom Cleaners",
          "Toilet Papers & Wipe",
          "Disinfectant Wipe",
        ],
      },
      {
        name: "Beer, Wine & Spirit",
        menu: ["Beer", "Vodka", "Red wine", "Whiskey", "Liquors", "Champaigne"],
      },
    ],
  },
  {
    name: "Fashion",
    data: [
      {
        name: "Fashion Cupboard",
        menu: [
          "Rice",
          "Yam",
          "Cassava Flour",
          "Beans",
          "Poundo Yam",
          "Yam Flour",
        ],
      },
      {
        name: "Fruits",
        menu: ["Grape", "Apple", "Peer", "Orange", "Pineapple", "Apple"],
      },
      {
        name: "Household Cleaning",
        menu: [
          "Laundry",
          "Air Fresher",
          "Dishwashing",
          "Bathroom Cleaners",
          "Toilet Papers & Wipe",
          "Disinfectant Wipe",
        ],
      },
      {
        name: "Beer, Wine & Spirit",
        menu: ["Beer", "Vodka", "Red wine", "Whiskey", "Liquors", "Champaigne"],
      },
    ],
  },
  {
    name: "Baby Products",
    data: [
      {
        name: "Baby Cupboard",
        menu: [
          "Rice",
          "Yam",
          "Cassava Flour",
          "Beans",
          "Poundo Yam",
          "Yam Flour",
        ],
      },
      {
        name: "Fruits",
        menu: ["Grape", "Apple", "Peer", "Orange", "Pineapple", "Apple"],
      },
      {
        name: "Household Cleaning",
        menu: [
          "Laundry",
          "Air Fresher",
          "Dishwashing",
          "Bathroom Cleaners",
          "Toilet Papers & Wipe",
          "Disinfectant Wipe",
        ],
      },
      {
        name: "Beer, Wine & Spirit",
        menu: ["Beer", "Vodka", "Red wine", "Whiskey", "Liquors", "Champaigne"],
      },
    ],
  },
  {
    name: "Gaming",
    data: [
      {
        name: "Gaming Cupboard",
        menu: [
          "Rice",
          "Yam",
          "Cassava Flour",
          "Beans",
          "Poundo Yam",
          "Yam Flour",
        ],
      },
      {
        name: "Fruits",
        menu: ["Grape", "Apple", "Peer", "Orange", "Pineapple", "Apple"],
      },
      {
        name: "Household Cleaning",
        menu: [
          "Laundry",
          "Air Fresher",
          "Dishwashing",
          "Bathroom Cleaners",
          "Toilet Papers & Wipe",
          "Disinfectant Wipe",
        ],
      },
      {
        name: "Beer, Wine & Spirit",
        menu: ["Beer", "Vodka", "Red wine", "Whiskey", "Liquors", "Champaigne"],
      },
    ],
  },
  {
    name: "Sporting",
    data: [
      {
        name: "Sporting Cupboard",
        menu: [
          "Rice",
          "Yam",
          "Cassava Flour",
          "Beans",
          "Poundo Yam",
          "Yam Flour",
        ],
      },
      {
        name: "Fruits",
        menu: ["Grape", "Apple", "Peer", "Orange", "Pineapple", "Apple"],
      },
      {
        name: "Household Cleaning",
        menu: [
          "Laundry",
          "Air Fresher",
          "Dishwashing",
          "Bathroom Cleaners",
          "Toilet Papers & Wipe",
          "Disinfectant Wipe",
        ],
      },
      {
        name: "Beer, Wine & Spirit",
        menu: ["Beer", "Vodka", "Red wine", "Whiskey", "Liquors", "Champaigne"],
      },
    ],
  },
  {
    name: "Phones",
    data: [
      {
        name: "Phones Cupboard",
        menu: [
          "Rice",
          "Yam",
          "Cassava Flour",
          "Beans",
          "Poundo Yam",
          "Yam Flour",
        ],
      },
      {
        name: "Fruits",
        menu: ["Grape", "Apple", "Peer", "Orange", "Pineapple", "Apple"],
      },
      {
        name: "Household Cleaning",
        menu: [
          "Laundry",
          "Air Fresher",
          "Dishwashing",
          "Bathroom Cleaners",
          "Toilet Papers & Wipe",
          "Disinfectant Wipe",
        ],
      },
      {
        name: "Beer, Wine & Spirit",
        menu: ["Beer", "Vodka", "Red wine", "Whiskey", "Liquors", "Champaigne"],
      },
    ],
  },
  {
    name: "Automobile",
    data: [
      {
        name: "Automobile Cupboard",
        menu: [
          "Rice",
          "Yam",
          "Cassava Flour",
          "Beans",
          "Poundo Yam",
          "Yam Flour",
        ],
      },
      {
        name: "Fruits",
        menu: ["Grape", "Apple", "Peer", "Orange", "Pineapple", "Apple"],
      },
      {
        name: "Household Cleaning",
        menu: [
          "Laundry",
          "Air Fresher",
          "Dishwashing",
          "Bathroom Cleaners",
          "Toilet Papers & Wipe",
          "Disinfectant Wipe",
        ],
      },
      {
        name: "Beer, Wine & Spirit",
        menu: ["Beer", "Vodka", "Red wine", "Whiskey", "Liquors", "Champaigne"],
      },
    ],
  },
  {
    name: "Home and Office",
    data: [
      {
        name: "Home Cupboard",
        menu: [
          "Rice",
          "Yam",
          "Cassava Flour",
          "Beans",
          "Poundo Yam",
          "Yam Flour",
        ],
      },
      {
        name: "Fruits",
        menu: ["Grape", "Apple", "Peer", "Orange", "Pineapple", "Apple"],
      },
      {
        name: "Household Cleaning",
        menu: [
          "Laundry",
          "Air Fresher",
          "Dishwashing",
          "Bathroom Cleaners",
          "Toilet Papers & Wipe",
          "Disinfectant Wipe",
        ],
      },
      {
        name: "Beer, Wine & Spirit",
        menu: ["Beer", "Vodka", "Red wine", "Whiskey", "Liquors", "Champaigne"],
      },
    ],
  },
  {
    name: "Other Category",
    data: [
      {
        name: "Other Cupboard",
        menu: [
          "Rice",
          "Yam",
          "Cassava Flour",
          "Beans",
          "Poundo Yam",
          "Yam Flour",
        ],
      },
      {
        name: "Fruits",
        menu: ["Grape", "Apple", "Peer", "Orange", "Pineapple", "Apple"],
      },
      {
        name: "Household Cleaning",
        menu: [
          "Laundry",
          "Air Fresher",
          "Dishwashing",
          "Bathroom Cleaners",
          "Toilet Papers & Wipe",
          "Disinfectant Wipe",
        ],
      },
      {
        name: "Beer, Wine & Spirit",
        menu: ["Beer", "Vodka", "Red wine", "Whiskey", "Liquors", "Champaigne"],
      },
    ],
  },
];
